import type React from 'react';
import { useContext } from 'react';
import { Chat } from '../components/Chat';
import { GuardianContext } from '../components/GuardianProvider';
import { WelcomeScreen } from '../components/welcome-page/WelcomeScreen';
import { useChat } from '../hooks/useChat';

/** Conversation mode content: the welcome screen or the active chat (the widget panel wraps the routes). */
export const ConversationView: React.FC = () => {
  const { selectedAgent } = useContext(GuardianContext);
  const { conversation } = useChat();
  const isChatEmpty = conversation.isNew && !selectedAgent?.landingPage;

  return (
    <>
      {isChatEmpty && <WelcomeScreen />}
      {!isChatEmpty && <Chat />}
    </>
  );
};
